import React from "react";
import ExpenseTypeMaster from "../../../components/Master/ExpenseType/expensetypemaster.component"

export default class ExpenseTypeScreen extends React.Component {
  render() {
    return (
      <div >
        <ExpenseTypeMaster></ExpenseTypeMaster>
      </div>
    );
  }
}